export default "__VITE_PUBLIC_ASSET__9198e2e2__"